import { render, staticRenderFns } from "./ResultGoodsSellersDetail.vue?vue&type=template&id=1530b98e&scoped=true&"
import script from "./ResultGoodsSellersDetail.vue?vue&type=script&lang=js&"
export * from "./ResultGoodsSellersDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResultGoodsSellersDetail.vue?vue&type=style&index=0&id=1530b98e&scoped=true&lang=css&"
import style1 from "./ResultGoodsSellersDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530b98e",
  null
  
)

export default component.exports